import {
  Feedback,
  FeedbackRequest,
} from "@/redux/feedback/types/Feedback.interface";

import { api } from "./instance";
const _feedbackService = {
  getFeedbacks: async () => {
    const response = await api.get<Feedback[]>(`/feedback`);
    return response.data;
  },
  createFeedback: async (feedback: FeedbackRequest, images?: File[]) => {
    const formData = new FormData();
    Object.entries(feedback).forEach(([key, value]) => {
      formData.append(key, value);
    });

    if (images && images.length > 0) {
      images.forEach((image) => {
        formData.append("images", image);
      });
    }

    const response = await api.post<string>(`/feedback`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
  updateFeedbacks: async (feedbacks: Feedback[]) => {
    const response = await api.patch<{ message: string }>(
      `/feedback`,
      feedbacks,
    );
    return response.data;
  },
  getFeedbackImages: async (feedbackId: string) => {
    const response = await api.get<string[]>(`/feedback/${feedbackId}/images`);
    return response.data;
  },
};

export default _feedbackService;
